
import React from "react";
import "./AmpArrowTooltip.css";

interface AmpArrowTooltipProps {
    title: string,
    items: Array<string>;
    element?: JSX.Element;
    className?: string;
}

export default function AmpArrowTooltip(props: AmpArrowTooltipProps) {

    return (
        <>
            <div className="position-relative">
                <div className={"arrow_tooltip" + (props.className ? " " + props.className: "")}>
                    <span className="tip"></span>
                    <div className="padding-content">
                        {props.title}
                        <br />
                        {
                            props.items.map((item, key) => {
                                return <li key={key}>{item}</li>
                            })
                        }
                    </div>
                    {
                        props.element
                    }
                </div>
            </div>
        </>
    )
}
